import _ from 'lodash'
import config from 'scoreboard/components/config'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import i18n from 'scoreboard/components/i18n'
import ObjectSelectorMenu from 'scoreboard/components/bootslide/object-selector-menu'
const { SectionLabel } = ObjectSelectorMenu
import constants from 'scoreboard/components/constants'
const { UNSCORED, UNSCORED_TEXT } = constants

/**
 * Tooltip that holds options to add new subscription alerts.
 * @property [model] The domain model owning the subscription. May be null if
 * 					 adding a subscription before an object was picked (ex. from
 * 					 the "My Alert Subscriptions" page)
 */
const SubscriptionFormTooltip = BootslideMenu.extend({
	/**
	 * @param [options.subscriptions=true] Show alert subscription menu option.
	 */
	initialize: function (options = {}) {
		BootslideMenu.prototype.initialize.apply(this, arguments)
		this.options = _.extend({subscriptions: true}, options)
	},

	menu: function () {
		let width = 210
		let topLevel = []

		let subscriptionTarget = ({ label, section, type, icon }) => {
			let target = {
				label: i18n.get(label),
				target: (e) => {
					e.preventDefault()

					this.trigger('done', { section, type })
				}
			}

			if (icon) {
				target.contentView = SectionLabel.extend({ svgIcon: icon, label, section })
			}

			return target
		}

		const {type, sourceType, scoringTypeId} = _.get(this.model, 'attributes', {})
		const isMetric = 'metric' === type || 'metric' === sourceType

		// #47708 don't display the 'Score Change' menu item for unscored metrics
		let isUnscoredMetric = false
		if (isMetric) {
			let scoringType = config.scoringType(scoringTypeId)
			if (_.get(scoringType, 'standardScoringType') == UNSCORED ||
				_.get(scoringType, 'kpiValueType') == UNSCORED_TEXT) {
				isUnscoredMetric = true
			}
		}

		if (config.scoresVisible && !isUnscoredMetric) {
			topLevel.push(subscriptionTarget({ label: 'alerts.scoreChange', section: 'scorecards', type: 'score-changed' }))
		}

		// If this is an alert for a metric, or no scorecard item has been provided,
		// show the "value changed" option
		if (isMetric || !type) {
			topLevel.push(subscriptionTarget({ label: 'alerts.metricValueChange', section: 'scorecards', type: 'metric-value-changed' }))
		}

		topLevel.push(subscriptionTarget({ label: 'alerts.commentsAdded', section: 'scorecards', type: 'comment-added' }))

		if (this.options.subscriptions) {
			const target = []
			if (config.displayStrategyMaps) {
				target.push(subscriptionTarget({ label: 'strategyMaps.strategyMap',
					section: 'strategyMaps', type: 'change-published', icon: 'strategy-map' }))
			}
			target.push(subscriptionTarget({ label: 'dashboards.dashboard',
				section: 'dashboards', type: 'change-published', icon: 'dashboard' }))

			target.push(subscriptionTarget({ label: 'report.report',
				section: 'reports', type: 'change-published', icon: 'reports' }))

			target.push(subscriptionTarget({ label: 'charts.chart',
				section: 'charts', type: 'change-published', icon: 'chart'
			}))

			target.push(subscriptionTarget({ label: 'briefingBooks.briefing',
				section: 'briefings', type: 'change-published', icon: 'briefings' }))

			let submenu = {
				label: i18n.get('alerts.subscription'),
				target,
				width
			}

			topLevel.push(submenu)
		}

		return {
			label: i18n.get('alerts.addAlert'),
			target: topLevel,
			width
		}
	}
})

export default SubscriptionFormTooltip

SubscriptionFormTooltip.__filename__ = 'alerts/subscription-type-tooltip.js'
